import React from 'react';
import { BsFillInfoCircleFill, BsPlus, BsX } from 'react-icons/bs';
import { Box, HStack, Icon, IconButton, Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton, PopoverContent,
  PopoverTrigger,
  Text, VStack } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { chunkArray, sortAlphaNumeric } from '../../../../utils/arrayUtil';
import SelectItemTableCodes from '../SelectItemTableCodes';

import SelectedCodeBubble from './SelectedCodeBubble';

function SelectedCodesList({ codeMap, addCodeType }) {
  const selectedCodes = Object.values(codeMap).filter(code => code.checked);
  const sortedCodes = selectedCodes.sort(sortAlphaNumeric('letter'));
  const chunkedCodes = chunkArray(sortedCodes, 10);

  return (
    <Box justifyContent="flex-start" ml={4}>
      <VStack alignItems="flex-start">
        <HStack alignItems="baseline">
          <Popover trigger="hover">
            <PopoverTrigger>
              <IconButton
                icon={<Icon as={BsFillInfoCircleFill} boxSize={4} />}
                variant="textGrey"
              />
            </PopoverTrigger>
            <PopoverContent maxW="600px">
              <PopoverArrow />
              <PopoverBody p={4} textAlign="left">
                <Box fontSize="md" mb={4}>
                  The codes selected here will be used when using the
                  <Box as="span" fontWeight="semibold">{' {{items_with_codes}} '}</Box>
                  token.  The resulting items table that appears in the email will include items that have only these selected codes with an applied or suggested status.
                </Box>
                <Box mb={4}>
                  To add or remove codes, use the
                  <Box as="span">
                    <Icon as={BsPlus} boxSize={5} color="primaryScale.600" />
                  </Box>
                  icon.  You can also click the
                  <Box as="span">
                    <Icon as={BsX} boxSize={5} color="greyScale.900" />
                  </Box>
                  icon next to the code letter to remove codes quickly.
                </Box>
                <Text
                  fontSize="md"
                  fontWeight="semibold"
                >
                  Note: If no codes are selected but the token is used in the email, the default will be to use all codes in the items table.
                </Text>
              </PopoverBody>
            </PopoverContent>
          </Popover>
          <Text
            fontSize="sm"
            fontWeight="semibold"
            textAlign="left"
            width="250px"
          >
            Showing Items with Selected Codes:
          </Text>
        </HStack>
        <Box>
          { selectedCodes.length
            ? (
              <VStack alignItems="flex-start">
                { chunkedCodes.map((codes, i) => (
                  <HStack>
                    { codes.map((code, j) => (
                      <>
                        <SelectedCodeBubble id={code.id} letter={code.letter} />
                        { chunkedCodes.length === (i + 1) && codes.length === (j + 1) && (
                          <SelectItemTableCodes type={addCodeType} />
                        )}
                      </>
                    ))}
                  </HStack>
                ))}
              </VStack>

            )
            : (
              <HStack alignItems="baseline">
                <Text
                  fontSize="sm"
                  fontStyle="italic"
                >
                  All codes selected by default
                </Text>
                <SelectItemTableCodes type={addCodeType} />
              </HStack>
            )}
        </Box>
      </VStack>
    </Box>
  );
}

SelectedCodesList.propTypes = {
  codeMap: PropTypes.objectOf(PropTypes.object),
  addCodeType: PropTypes.oneOf(['modal', 'popover'])
};

export default SelectedCodesList;
